import React, { useState } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { useIntl, FormattedMessage } from 'react-intl'

import { FULLY_LISTENED, PARTIALY_LISTENED } from 'app/constants/messageDetail'

import DisplaySubscriber from './DisplaySubscriber'
import StackedBarChart from '../components/StackedBarChart'
import SubscriberListWithTabs from './SubscriberListWithTabs'

const TextToSpeech = (props) => {
  const { data } = props
  const { fullListened, listened } = data || {}

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const readCount = R.isEmpty(data) ? 0 : R.length(fullListened ?? [])
  const feedCount = R.isEmpty(data) ? 0 : R.length(listened ?? [])

  const subscriberListen = [
    {
      name: PARTIALY_LISTENED,
      label: formatMessage({
        id: 'metrics.listened',
      }),
      subscribers: listened,
      emptyMessage: formatMessage({
        id: 'metrics.partialy.listened.empty.message',
      }),
      color: '#FFA700',
      lableTooltip: null,
      value: feedCount,
    },
    {
      name: FULLY_LISTENED,
      label: formatMessage({
        id: 'metrics.full.listened',
      }),
      subscribers: fullListened,
      emptyMessage: formatMessage({
        id: 'metrics.fully.listened.empty.message',
      }),
      color: '#4FD975',
      lableTooltip: null,
      value: readCount,
    },
  ]

  return (
    <>
      <div className="space-y-3 px-5 py-10">
        <Typography className="font-bold flex items-center text-grey-400 font-medium">
          {formatMessage({
            id: 'metrics.view.rate',
          })}
        </Typography>
        {R.isEmpty(listened) ? null : (
          <div className="flex">
            <span
              className="w-3 h-3 mt-2 mr-3 rounded-full"
              style={{ backgroundColor: '#FFA700' }}
            />
            <Typography className="text-12 text-grey-400">
              <FormattedMessage
                id="metrics.listened.message"
                values={{
                  count: feedCount,
                }}
              />
            </Typography>
          </div>
        )}
        {R.isEmpty(fullListened) ? null : (
          <div className="flex mt-10">
            <span
              className="w-3 h-3 mt-2 mr-3 rounded-full"
              style={{ backgroundColor: '#4FD975' }}
            />
            <Typography className="text-12 text-grey-400">
              <FormattedMessage
                id="metrics.full.listened.message"
                values={{
                  count: readCount,
                }}
              />
            </Typography>
          </div>
        )}

        <StackedBarChart data={subscriberListen} />
        <div className="flex justify-between">
          {R.isEmpty(R.concat(listened, fullListened)) ? null : (
            <DisplaySubscriber
              data={R.concat(listened, fullListened)}
              onClick={() => setIsOpen(true)}
            />
          )}
        </div>
      </div>

      <SubscriberListWithTabs
        data={subscriberListen}
        title={formatMessage({ id: 'metrics.listen.title' })}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
      />
    </>
  )
}

const object = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  avatarCharacters: PropTypes.string,
  lastSeen: PropTypes.string,
}
TextToSpeech.propTypes = {
  data: PropTypes.shape({
    fullListened: PropTypes.arrayOf(PropTypes.shape(object)),
    listened: PropTypes.arrayOf(PropTypes.shape(object)),
  }).isRequired,
}

export default TextToSpeech
